import type MixitoneController from "controllers/MixitoneController";
import { AppController } from "controllers/AppController";
import RouteController from "controllers/RouteController";
import { getSessionNavigationContext, type GlobalSearchResult } from "./globalSearchTypes";

export async function navigateToGlobalSearchResult(
  result: GlobalSearchResult,
  controller: MixitoneController<object>,
): Promise<void> {
  const app = controller.get(AppController);
  const route = controller.get(RouteController);
  const sessionContext = getSessionNavigationContext(
    route.state.location?.pathname ?? "",
    route.params.token,
    app.state.currentClub?.id,
    result.clubId,
  );

  if (app.state.currentClub?.id !== result.clubId) {
    await app.actionSetCurrentClubById(result.clubId);
  }

  switch (result.type) {
    case "club_player":
      if (sessionContext) {
        controller.actionOpenModal("/t/:token/:clubId/players/:id/edit", {
          viewTransition: false,
          params: {
            token: sessionContext.token,
            clubId: sessionContext.clubId,
            id: result.id,
          },
        });
        return;
      }
      controller.actionOpenModal("/clubs/:clubId/players/:id/edit", {
        params: { clubId: result.clubId, id: result.id },
      });
      return;
    case "group":
      controller.actionOpenModal("/clubs/:clubId/groups/:id/edit", {
        params: { clubId: result.clubId, id: result.id },
      });
      return;
    case "tournament_session":
      controller.actionForward("/tournament/:id", {
        params: { id: result.id },
      });
      return;
    case "tournament_player":
      controller.actionOpenModal("/tournament/:id/players/:playerId/edit", {
        params: {
          id: result.tournamentSessionId ?? result.id,
          playerId: result.id,
        },
      });
      return;
    case "funder":
    case "funding_appeal":
    case "funding_outreach":
      return;
  }
}
